import * as React from 'react';

import { IMPORT_STATE } from '@klareospace/pharos-lib-types';
import type { ImportState } from '@klareospace/pharos-lib-types';

import { StatusBadge } from '../status-badge/status-badge';
import { STATUS_BADGE_COLORS } from '../status-badge/status-badge-colors';

// ─── Constants ────────────────────────────────────────────────────────────────

export const IMPORT_STATUS_BADGE_COLORS: Record<ImportState, string> = {
  [IMPORT_STATE.ERROR]: STATUS_BADGE_COLORS.danger,
  [IMPORT_STATE.PARTIAL]: STATUS_BADGE_COLORS.warning,
  [IMPORT_STATE.PENDING]: STATUS_BADGE_COLORS.in_progress,
  [IMPORT_STATE.SUCCESS]: STATUS_BADGE_COLORS.success,
};

// ─── Types ────────────────────────────────────────────────────────────────────

export interface ImportStatusBadgeProps {
  /** The translated label to show inside the badge */
  label: string;
  /** The import state value used to look up the badge colour */
  state: ImportState;
}

// ─── Component ────────────────────────────────────────────────────────────────

/** Displays an import history row's state as a coloured badge — success/partial/error/pending. */
export function ImportStatusBadge({ label, state }: ImportStatusBadgeProps): React.JSX.Element {
  return <StatusBadge label={label} status={state} styles={IMPORT_STATUS_BADGE_COLORS} />;
}
